import { Controller } from '@hotwired/stimulus';

// Seek YouTube embed when transcript timestamps are clicked.
export default class extends Controller {
  static targets = ['iframe'];
  static values = { videoId: String };

  seek(event) {
    const startMs = event.params.startMs;
    if (startMs == null) return;

    const seconds = Number(startMs) / 1000;
    const iframe = this.iframeTarget;
    if (!iframe?.contentWindow) return;

    iframe.contentWindow.postMessage(
      JSON.stringify({
        event: 'command',
        func: 'seekTo',
        args: [seconds, true]
      }),
      '*'
    );
  }
}
